import { useInjection } from '../di';
import { MODAL_MANAGER } from './di';
import { IModalManager } from './manager.interface';

export const useManager = (): IModalManager => useInjection(MODAL_MANAGER);
